import { styled } from '@mui/material/styles';

const StyledNavBarLogoSection = styled('nav')`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

export default StyledNavBarLogoSection;
